export const DEFAULT_ASSIGN = 'DEFAULT_ASSIGN';
// export const SET_FACTORYS = 'SET_FACTORYS';

export default {
	DEFAULT_ASSIGN
	// SET_FACTORYS
};
